import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowDown, ArrowUp } from "lucide-react";

/**
 * KeyboardHints — small pill at bottom-left telling users they can use
 * arrow keys / single scroll to jump between sections.
 *
 * Auto-hides after 7s OR after the first user keypress.
 */
const KeyboardHints = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = window.setTimeout(() => setVisible(false), 7000);
    const onKey = (e) => {
      if (
        e.key === "ArrowDown" ||
        e.key === "ArrowUp" ||
        e.key === "PageDown" ||
        e.key === "PageUp" ||
        e.key === " "
      ) {
        setVisible(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="keyboard-hints"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.6, delay: 1.5 }}
          className="fixed bottom-6 left-6 md:bottom-8 md:left-8 z-50 hidden sm:flex items-center gap-3 px-4 py-3 bg-ink-2/80 backdrop-blur-md border border-warm-border rounded-full"
        >
          <span className="flex items-center gap-1">
            <kbd className="font-sans text-[10px] uppercase tracking-wider text-parchment border border-warm-border px-2 py-1 leading-none bg-ink/60">
              <ArrowUp size={10} className="inline -mt-px" />
            </kbd>
            <kbd className="font-sans text-[10px] uppercase tracking-wider text-parchment border border-warm-border px-2 py-1 leading-none bg-ink/60">
              <ArrowDown size={10} className="inline -mt-px" />
            </kbd>
          </span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-warm-muted">
            atau scroll · pindah bagian
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default KeyboardHints;
